import React, { useEffect,useState } from "react"
import {useLazyQuery} from '@apollo/client'
import {GETLANGUAGE, GETPRODUCTSETUP, KEY_PERFORMANCE_METRICS_FILTER} from '../../../../utils/GraphQLAPI'
import filterIcon from '../../../../_metronic/images/filter.svg'
import filterFillIcon from '../../../../_metronic/images/filter-fill.svg'

const TPVFilter=({filterOptions,setFilterOptions}:any)=>{
  const networkOnly = 'network-only'
  const [localFilterOptions, setLocalFilterOptions] = useState<any>({
    commodityId: null,
    isActive: null,
    languageId: null,
    page: 1,
    perPage: 10,
    salesChannelId: null,
    searchText: '',
    utilityId: null,
  })
  const [initialFilter, setInitialFilter] = useState<any>()

  const [getLanguage,{data:languageData}]=useLazyQuery(GETLANGUAGE,{
    fetchPolicy: networkOnly,
  })
      
  const [getSalesChannelsForFilter,{data:salesChannelData}] = useLazyQuery(KEY_PERFORMANCE_METRICS_FILTER, {
    fetchPolicy: networkOnly,
    onCompleted: (scData) => {
      console.log("Sales Channel Data", scData)
    },
  })

  const [getFilter, {data}] = useLazyQuery(GETPRODUCTSETUP, {
    variables: {
      productDetailByTypeInput:{
        type: ["COMMODITY","UTILITY"]
      }
    },
    onCompleted: (_data: any) => {
      console.log("filter Data", _data)
    },
    onError: (err) => console.log('error', err),
    fetchPolicy: networkOnly,
  })

  useEffect(()=>{
    setInitialFilter(localFilterOptions);
  },[])

  const handleSelectChange = (value: any, option: any) => {
    if (option === 'active') {
      if (value === 'null') {
        //while changing filter the filter should apply with the search text
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, isActive: null}
        })
      } else {
        const flag = value === 'true' ? true : false
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, isActive: flag}
        })
      }
    } else if (option === 'UTILITY') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, utilityId: null}
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, utilityId: value}
        })
      }
    } else if (option === 'COMMODITY') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, commodityId: null}
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, commodityId: value}
        })
      }
    } else if (option === 'LANGUAGE') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, languageId: null}
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, languageId: value}
        })
      }
    } else if (option === 'SALESCHANNEL') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, salesChannelId: null}
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return {...prevOptions, searchText: filterOptions.searchText, salesChannelId: value}
        })
      }
    }
  }

  return(
    <div className='m-0'>
      <button
        className='btn btn-light-primary btn-active-light-primary fw-bold fs-base'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        onClick={() => {
          getFilter()
          getLanguage()
          getSalesChannelsForFilter()
        }}
      >
        <img
          src={JSON.stringify({...initialFilter}) === JSON.stringify({...filterOptions,page: 1,perPage: 10,searchText: ''}) ? filterIcon : filterFillIcon}
          alt=''
          className='svg-icon svg-icon-1'
        />
        Filter
      </button>

      <div
        className='menu menu-sub menu-sub-dropdown w-350px w-md-550px'
        data-kt-menu='true'
        id='kt_menu_63b3cb4f9c1ef'
      >
        <div className='px-7 py-5'>
          <div className='fs-4 fw-bold text-gray-900'>Filter Options</div>
        </div>
        <div className='separator border-gray-200'></div>
        <div className='px-7 py-5'>
          <div className='row row-cols-1 row-cols-lg-2'>
            {data &&
              data?.getProductDetail.map((item: any) => {
                if (item.enum === 'UTILITY') {
                  return (
                    <div className='col mb-3'>
                      <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                        <span>{item.type}</span>
                      </label>
                      <select
                        className='form-select form-select-solid'
                        value={
                          localFilterOptions.utilityId === null
                            ? '0'
                            : localFilterOptions.utilityId
                        }
                        onChange={(e) => handleSelectChange(e.target.value, item.enum)}
                        aria-label='Select example'
                      >
                        <option value='0'>Select an option</option>
                        {item.names.map((options: any) => {
                          return <option value={options.id}>{options.value}</option>
                        })}
                      </select>
                    </div>
                  )
                } else if (item.enum === 'COMMODITY') {
                  return (
                    <div className='col mb-3'>
                      <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                        <span>{item.type}</span>
                      </label>
                      <select
                        className='form-select form-select-solid'
                        value={
                          localFilterOptions.commodityId === null
                            ? '0'
                            : localFilterOptions.commodityId
                        }
                        onChange={(e) => handleSelectChange(e.target.value, item.enum)}
                        aria-label='Select example'
                      >
                        <option value='0'>Select an option</option>
                        {item.names.map((options: any) => {
                          return <option value={options.id}>{options.value}</option>
                        })}
                      </select>
                    </div>
                  )
                }
              })
            }

            {languageData &&
              <div className='col mb-3'>
                <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                  <span>Language</span>
                </label>
                <select
                  className='form-select form-select-solid'
                  value={
                    localFilterOptions.languageId === null
                      ? '0'
                      : localFilterOptions.languageId
                  }
                  onChange={(e) => handleSelectChange(e.target.value, "LANGUAGE")}
                  aria-label='Select example'
                >
                  <option value='0'>Select an option</option>
                  {languageData.getAllLanguages.map((options: any) => {
                    return <option value={options.id}>{options.languageName}</option>
                  })}
                </select>
              </div>
            }

            {salesChannelData &&
              <div className='col mb-3'>
                <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                  <span>Sales Channel</span>
                </label>
                <select
                  className='form-select form-select-solid'
                  value={
                    localFilterOptions.salesChannelId === null
                      ? '0'
                      : localFilterOptions.salesChannelId
                  }
                  onChange={(e) => handleSelectChange(e.target.value, "SALESCHANNEL")}
                  aria-label='Select example'
                >
                  <option value='0'>Select an option</option>
                  {salesChannelData.getSalesChannelListByTeamAdminWithFilter.salesChannels.map((options: any) => {
                    return <option value={options.id}>{options.name}</option>
                  })}
                </select>
              </div>   
            }

            <div className='col mb-3'>
              <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                <span>Script Status</span>
              </label>
              <select
                className='form-select form-select-solid'
                value={
                  localFilterOptions.isActive === null
                    ? 'null'
                    : localFilterOptions.isActive
                }
                onChange={(e) => handleSelectChange(e.target.value, 'active')}
                aria-label='Select example'
              >
                <option value='null'>Select an option</option>
                <option value='true'>Active</option>
                <option value='false'>Inactive</option>
              </select>
            </div>
          </div>

          <div className='d-flex flex-row justify-content-end mt-4'>
            <button
              type='button'
              className='btn btn-light me-3 fs-7 fw-semibold text-gray-600'
              onClick={() => {
                setLocalFilterOptions({
                  commodityId: null,
                  isActive: null,
                  languageId: null,
                  page: 1,
                  perPage: 10,
                  salesChannelId: null,
                  searchText: filterOptions.searchText,
                  utilityId: null,
                })
              }}
            >
              Reset
            </button>
            <button
              type='button'
              data-kt-menu-dismiss='true'
              onClick={() => setFilterOptions({...localFilterOptions, page: 1})}
              className='btn btn-primary fs-7 fw-semibold text-gray-100'
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TPVFilter
